import Route from '@ember/routing/route'
import { service } from '@ember/service'
import RSVP from 'rsvp'
import type { NormalizedInterval } from 'date-fns'
import type { StudentsScope } from 'teacher-ui-client/reporting/ui-scope/utils'
import type ReportingUiScopeRoute from 'teacher-ui-client/reporting/ui-scope/route'
import type StudentEventsService from 'teacher-ui-client/services/student-events'

export default class RexTimeOnTaskRoute extends Route {
  @service studentEvents!: StudentEventsService

  async model() {
    const { uiScope, scopedData, period } = this.modelFor('reporting.ui-scope') as ModelFor<ReportingUiScopeRoute>

    const scopedStudents = scopedData.students
    const statsScope: StudentsScope = { scope: 'students', ids: scopedStudents.map((s) => s.id) }

    const product: LegacyProductRex = 'rex'
    const useV2 = window.localStorage.getItem('totV2') === 'true'
    const stats = useV2
      ? await this.makeStatsRequestsV2(product, statsScope, period)
      : await this.makeStatsRequests(product, statsScope, period)

    return { uiScope, scopedStudents, ...stats }
  }

  makeStatsRequests = async (product: LegacyProductRex, scope: StudentsScope, period: NormalizedInterval) => {
    const { studentEvents } = this

    return RSVP.hash({
      timeOnTaskHistory: studentEvents.timeOnTaskHistory(product, scope, period),
      timeOnTaskUsage: studentEvents.timeOnTaskUsage(product, scope, period),
    })
  }

  makeStatsRequestsV2 = async (product: LegacyProductRex, scope: StudentsScope, period: NormalizedInterval) => {
    const { studentEvents } = this
    return RSVP.hash({
      timeOnTaskHistory: studentEvents.timeOnTaskHistoryV2(product, scope, period),
      timeOnTaskUsage: studentEvents.timeOnTaskUsageV2(product, scope, period),
    })
  }
}
